import React from 'react';
import { motion } from 'framer-motion';
import { DivineBackdrop, OrnateGoldBadge, GoldFooterPill, BODY_FONT_STYLE } from './shared';

const OfferingDisplay = ({ content }) => (
  <div className="w-full h-full relative overflow-hidden" data-testid="offering-display" style={{ height: '100vh' }}>
    <DivineBackdrop />
    <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-12">
      <motion.div initial={{ opacity: 0, y: -24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.55 }}>
        <OrnateGoldBadge>{content?.title || 'OFFERING & THANKSGIVING'}</OrnateGoldBadge>
      </motion.div>

      {/* Decorative offering icon in gold */}
      <motion.div
        initial={{ scale: 0.6, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.15, duration: 0.7, type: 'spring' }}
        style={{ margin: '3vh 0 2vh', color: '#fde68a', filter: 'drop-shadow(0 0 20px rgba(251,191,36,0.45))' }}
      >
        <svg width="72" height="72" fill="currentColor" viewBox="0 0 24 24" aria-hidden>
          <path d="M20 7h-1.209A4.92 4.92 0 0019 5.5C19 3.57 17.43 2 15.5 2c-1.622 0-2.705 1.482-3.404 3.085C11.498 3.357 10.391 2 8.5 2 6.57 2 5 3.57 5 5.5c0 .596.079 1.089.209 1.5H4c-1.1 0-2 .9-2 2v2c0 .55.45 1 1 1v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7c.55 0 1-.45 1-1V9c0-1.1-.9-2-2-2zm-4.5-3c.83 0 1.5.67 1.5 1.5S16.33 7 15.5 7H13c.5-1.58 1.35-3 2.5-3zM7 5.5C7 4.67 7.67 4 8.5 4c1.15 0 2 1.42 2.5 3H8.5C7.67 7 7 6.33 7 5.5zM4 9h7v2H4V9zm1 4h6v7H5v-7zm14 7h-6v-7h6v7zm1-9h-7V9h7v2z" />
        </svg>
      </motion.div>

      {content?.message && (
        <motion.p
          initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3, duration: 0.6 }}
          className="text-white"
          style={{
            ...BODY_FONT_STYLE,
            fontWeight: 900,
            fontSize: 'clamp(26px, 5.2vh, 72px)',
            lineHeight: 1.18,
            maxWidth: '85vw',
            margin: '0 0 1.5vh',
          }}
        >
          {content.message}
        </motion.p>
      )}

      {content?.scripture && (
        <motion.p
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.55, duration: 0.6 }}
          className="font-black tracking-[0.1em]"
          style={{
            color: '#fde68a',
            fontSize: 'clamp(16px, 2.8vh, 30px)',
            textShadow: '0 2px 8px rgba(0,0,0,0.8), 0 0 14px rgba(251,191,36,0.4)',
            fontFamily: '"Cinzel", "Playfair Display", Georgia, serif',
          }}
        >
          — {content.scripture}
        </motion.p>
      )}

      {content?.bank_details && (
        <motion.div
          initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.75, duration: 0.55 }}
          className="rounded-2xl px-8 py-5 max-w-3xl"
          style={{
            marginTop: '4vh',
            border: '1.5px solid rgba(251,191,36,0.55)',
            background: 'linear-gradient(180deg, rgba(16,32,74,0.7), rgba(6,12,30,0.75))',
            boxShadow: '0 0 22px rgba(251,191,36,0.18)',
            backdropFilter: 'blur(6px)',
          }}
        >
          <p className="uppercase tracking-[0.3em] mb-2 font-black" style={{ color: '#fde68a', fontSize: 'clamp(11px, 1.3vh, 14px)', fontFamily: '"Cinzel", Georgia, serif' }}>
            Bank Details
          </p>
          <p className="text-white/95 whitespace-pre-line" style={{ ...BODY_FONT_STYLE, fontWeight: 800, fontSize: 'clamp(15px, 2.2vh, 22px)', lineHeight: 1.45 }}>
            {content.bank_details}
          </p>
        </motion.div>
      )}

      {(content?.giving_url || content?.instructions) && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.0, duration: 0.6 }}
          style={{ marginTop: '3vh' }}
        >
          {content?.giving_url && (
            <GoldFooterPill>ONLINE GIVING · {content.giving_url}</GoldFooterPill>
          )}
          {content?.instructions && (
            <p className="text-white/70 mt-3" style={{ ...BODY_FONT_STYLE, fontWeight: 700, fontSize: 'clamp(14px, 2vh, 20px)', maxWidth: '60vw' }}>
              {content.instructions}
            </p>
          )}
        </motion.div>
      )}
    </div>
  </div>
);

export default OfferingDisplay;
